//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { debounce } from "quasar";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import AppPermissionsRoles from "./AppPermissionsRoles.vue";
import AppPermissionsUserGroupView from "./AppPermissionsUserGroupView.vue";
import AppEditPermissions from "./AppEditPermissions.vue";
import { PERMISSIONS_ROLES, SIDEBAR_SUBROLES, PERMISSIONS_TABS_ROLES, PERMISSIONS_TABS } from "./appPermissionsRolesConst";

export default {
    name: "AppPermissionsContainer",
    components: {
        AQTooltip,
        AQSearch,
        AQEmptySearch,
        AQSkeleton,
        AppPermissionsRoles,
        AppPermissionsUserGroupView,
        AppEditPermissions
    },
    data() {
        return {
            showSearch: false,
            searchValue: "",
            openRoleDetails: false,
            selectedTab: "tab-details",
            selectedPermissionTabs: "building-permissions-tab",
            usersGroupsItemsNr: 0,
            usersGroupsDescription: "",
            permissionsRoles: [],
            permissionTabsRole: {
                building: [],
                initiate: [],
                tasks: [],
                dataViews: [],
                analytics: [],
                settings: []
            },
            editPermissionModal: "",
            updateId: "",
            readonly: false,
            dynamicPermissions: [],
            rolePermissionsUserGroups: [],
            defaultPermissionsRoles: PERMISSIONS_ROLES,
            searchTrigger: false,
            skeletonState: true,
            firstTimeActivated: true,
            groupSidebar: [],
            roleContainerOpenedList: { SIDEBAR: false },
            sidebarSubroles: SIDEBAR_SUBROLES,
            defaultTabsRoles: PERMISSIONS_TABS_ROLES,
            permissionsTabs: PERMISSIONS_TABS,
            ownerRole: null,
            selectedRoleTab: "building-tab",
            queryToLoad: {},
            searchDone: false
        };
    },
    computed: {
        getItemResults() {
            // let data = this.selectedTab === "tab-details" ? this.permissionsRoles : this.rolePermissionsUserGroups;

            let results = 0;
            this.permissionsRoles.forEach(element => {
                results += element.children.length;
            });
            return results;
        },
        showResults() {
            return this.searchValue && this.searchValue.trim();
        },
        checkIfPermissionsTab() {
            return this.selectedTab === "tab-details";
        }
    },
    watch: {
        editPermissionModal(newValue, oldValue) {
            if (newValue && oldValue) {
                this.rolePermissionsUserGroups.forEach(element => {
                    if (element.id === newValue.id) {
                        element.permissions = newValue.permissions;
                    }
                });
                this.updateId = newValue.id;
                this.editPermissionModal = null;
            }
        },
        searchValue: {
            handler(newValue) {
                const newSearchValue = newValue ? newValue.trim() : "";
                this.searchItems(newSearchValue);
            }
        },
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    created() {
        this.checkPermissions();
        this.getPermissionsRoles(true);
        this.searchItems = debounce((data) => {
            this.permissionsRoles = [];
            this.skeletonState = true;
            if (data) {
                this.searchPermissionsRoles(data);
            } else {
                this.getPermissionsRoles();
            }
        }, 600);
        this.$root.$on("oneAtATime-permissions", () => {
            this.checkPermissions({ readonly: !this.$oneAtATime.state.$currentRoomEmpty });
        });
    },
    mounted() {
        this.focusOrUnfocusSearch();
    },
    activated() {
        if (this.firstTimeActivated) {
            this.firstTimeActivated = false;
        } else {
            this.getPermissionsRoles(true);
        }
    },
    deactivated() {
        this.selectedRoleTab = "building-tab";
    },
    methods: {
        ...mapActions("apps", ["actGetRoleUsersGroups", "actGetPermissionsRoles", "actGetPermissionsRolesOnSearch", "actGetCurrentAppUserPermissions"]),
        editItemPermission(item) {
            this.updateId = "";
            this.editPermissionModal = item;
        },
        searchPermissions(value) {
            this.queryToLoad = { ...this.$route.query };
            if (value) {
                this.queryToLoad.search = value;
            } else {
                delete this.queryToLoad.search;
            }
            const queriesAreDifferent = JSON.stringify(this.queryToLoad) !== JSON.stringify(this.$route.query);
            if (queriesAreDifferent) {
                this.$router.replace({ query: this.queryToLoad });
            }
            this.searchValue = value;
        },
        newItemPermissionsAdded() {
            if (this.showResults) {
                this.searchPermissionsRoles(this.searchValue);
            }
        },
        removePermission(id) {
            this.rolePermissionsUserGroups = this.rolePermissionsUserGroups.filter(element => element.id !== id);
        },
        getPermissionsRoles(onLoad) {
            this.skeletonState = true;
            this.actGetPermissionsRoles().then(
                data => {
                    const dataViewsItems = [];
                    this.skeletonState = false;
                    this.openRoleDetails = false;
                    this.permissionsRoles = data.data;
                    this.ownerRole = this.permissionsRoles.find(({ code }) => code === "OWNER");
                    this.permissionTabsRole = { building: [], initiate: [], tasks: [], dataViews: [], analytics: [], settings: [] };

                    this.permissionsRoles.forEach(role => {
                        if (role.code !== "OWNER") {
                            if (this.defaultPermissionsRoles.includes(role.code)) {
                                const tabRole = this.defaultTabsRoles.find(({ code }) => code === role.code);
                                if (tabRole) {
                                    const type = this.permissionsTabs[tabRole.index];
                                    if (role.code === "TASKS_MANAGER") {
                                        this.permissionTabsRole[type].unshift(role);
                                    } else {
                                        this.permissionTabsRole[type].push(role);
                                    }
                                }
                            } else {
                                dataViewsItems.push(role);
                            }
                        }
                    });

                    this.permissionTabsRole.dataViews = [...this.permissionTabsRole.dataViews, ...dataViewsItems];

                    if (onLoad) {
                        const { query } = this.$route;
                        if (query && Object.keys(query).length && query.tab) {
                            this.selectedRoleTab = query.search ? "building-tab" : `${query.tab}-tab`;
                            if (query.search) {
                                this.searchTrigger = true;
                                this.searchValue = query.search;
                            }
                        } else if (query && !Object.keys(query).length && !query.tab) {
                            this.$router.replace({ query: { tab: this.selectedRoleTab.split("-")[0] } });
                        }
                        this.dynamicPermissions = dataViewsItems;
                    }
                }
            );
        },
        searchPermissionsRoles(value) {
            this.actGetCurrentAppUserPermissions();
            this.actGetPermissionsRolesOnSearch(value).then(
                data => {
                    this.skeletonState = false;
                    this.openRoleDetails = true;
                    this.permissionsRoles = data.data;
                    this.ownerRole = this.permissionsRoles.find(({ code }) => code === "OWNER");
                    this.permissionTabsRole = { building: [], initiate: [], tasks: [], dataViews: [], analytics: [], settings: [] };

                    this.permissionsRoles.forEach(role => {
                        if (role.code !== "OWNER" || this.defaultPermissionsRoles.includes(role.code)) {
                            const tabRole = this.defaultTabsRoles.find(({ code }) => code === role.code);
                            if (tabRole) {
                                const type = this.permissionsTabs[tabRole.index];
                                if (role.code === "TASKS_MANAGER") {
                                    this.permissionTabsRole[type].unshift(role);
                                } else {
                                    this.permissionTabsRole[type].push(role);
                                }
                            }
                        }
                    });

                    this.selectedRoleTab = "building-tab";
                    this.openRoleDetails = true;
                    this.searchDone = true;
                }
            );
        },
        editDeleteItem(deleteItem) {
            if (this.showResults) {
                this.searchPermissionsRoles(this.searchValue);
            } else if (!deleteItem) {
                this.getPermissionsRoles();
            }
        },

        setShowSearch() {
            this.showSearch = true;
        },

        focusOrUnfocusSearch(data) {
            if (data) {
                document.removeEventListener("keydown", this.setShowSearch);
            } else {
                document.addEventListener("keydown", this.setShowSearch);
            }
        },
        checkReadonly() {
            let readonly = false;
            if (this.$route.params && this.$route.params.permissions) {
                readonly = this.$route.params.permissions.readonly
                                || (this.$route.params.permissions.permissionsData
                                && this.$route.params.permissions.permissionsData.hasOwnProperty("AS")
                                && this.$route.params.permissions.permissionsData.AS === "r");
            }
            return readonly;
        },
        checkPermissions(oneAtATimeParams) {
            if (this.checkReadonly()) {
                this.readonly = true;
            } else if (oneAtATimeParams && oneAtATimeParams.hasOwnProperty("readonly")) {
                this.readonly = oneAtATimeParams.readonly;
            } else {
                this.readonly = false;
            }
            this.$store.commit("main/setSaveBtnVisible", this.readonly);
            this.$root.$emit("setReadonlyTag", this.readonly);
        },
        getConstraints(roleItem) {
            const hasExtraRolesWithCode = ["INITIATOR"];
            const checkForExtraRoles = () => ({ name: roleItem.name, noDescription: true });
            const checkDefaultRoles = () => (this.defaultPermissionsRoles.includes(roleItem.code) ? {} : null);
            const checkDefaultRolesWithId = () => (roleItem.id && hasExtraRolesWithCode.includes(roleItem.code) ? checkForExtraRoles() : checkDefaultRoles());

            return checkDefaultRolesWithId() || { name: roleItem.name, description: this.$t("applicationPermissions.PerspectiveRoleDesc") };
        },
        changeTabState(type) {
            if (type !== this.$route.query.tab) {
                this.queryToLoad.tab = type;
                this.$router.replace({ query: this.queryToLoad });
            }
        },
        onTabTransition() {
            this.openRoleDetails = false;
            if (this.searchDone) {
                this.$nextTick(() => {
                    this.openRoleDetails = true;
                });
            }
            this.searchDone = false;
        },
        tabOpened() {
            this.searchDone = false;
        }
    }

};
